<script setup lang="ts">
import { nextTick, onMounted, onUnmounted, ref } from "vue";
import OKCancelModal from "../../components/OKCancelModal.vue";

const props = defineProps<{ poNumber: number; changes: string[] }>();
const content = ref<HTMLElement>();
let trigger: HTMLElement | null = null;

function trapFocus(event: KeyboardEvent): void {
  if (event.key !== "Tab") return;
  const dialog = content.value?.closest('[role="dialog"]');
  if (!dialog?.contains(document.activeElement)) return;
  const buttons = [
    ...dialog.querySelectorAll<HTMLButtonElement>("button:not([disabled])"),
  ];
  const first = buttons[0];
  const last = buttons.at(-1);
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last?.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first?.focus();
  }
}

onMounted(async () => {
  trigger =
    document.activeElement instanceof HTMLElement
      ? document.activeElement
      : null;
  document.addEventListener("keydown", trapFocus);
  await nextTick();
  const dialog = content.value?.closest('[role="dialog"]');
  dialog?.setAttribute("aria-label", `Updates to PO ${String(props.poNumber)}`);
  dialog?.querySelector<HTMLButtonElement>("button")?.focus();
});
onUnmounted(() => {
  document.removeEventListener("keydown", trapFocus);
  if (trigger?.isConnected) trigger.focus();
});
</script>

<template>
  <OKCancelModal :title="`Updates to PO ${poNumber}`" ok-button-text="Close">
    <div ref="content">
      <p>
        Committed local changes since generation. These are not saved to the
        source system.
      </p>
      <ol aria-label="Committed PO updates">
        <li v-for="(change, index) in changes" :key="index">{{ change }}</li>
      </ol>
    </div>
  </OKCancelModal>
</template>
